<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="primary">
      <b-navbar-brand href="#">Ravenhub</b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
       

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-text class="app-id-display">
          App ID: {{ravenAppId}}
          </b-nav-text>
          <b-nav-item class="nav-item-text" href="https://docs.ravenhub.io" target="_blank" v-b-tooltip.hover title="Help and docs">
            Help <b-icon icon="question-circle" ></b-icon>
          </b-nav-item>
          <b-nav-item-dropdown right toggle-class="nav-item-text">
            <!-- Using 'button-content' slot -->
            
            <template v-slot:button-content>
              <em>{{userEmail}}</em>
            </template>
            <b-dropdown-item href="#" to="/settings">Settings</b-dropdown-item>
            <b-dropdown-item href="#" v-on:click="logout">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

  </div>
</template>

<script>
import * as FullStory from '@fullstory/browser';
// @ is an alias to /src
// Your corresponding keys
var Parse = require('parse/node');
Parse.initialize(process.env.VUE_APP_PARSE_APP_ID, process.env.VUE_APP_PARSE_JS_KEY, process.env.VUE_APP_PARSE_MASTER_KEY);
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL;

FullStory.init({ orgId: 'TQAH4' });

export default {
  name: 'NavBarComponent',
  mounted: function () {
    
  },
  created() {
    var parseuser = JSON.parse(localStorage.getItem('parseuser'));
    console.log('parseuser = ' + parseuser);
    if (parseuser) {
      Parse.User.hydrate(parseuser).then((result) => {
        console.log("current user = " + Parse.User.current() + '\n result = ' + result);
        
        if (!Parse.User.current()) {
          this.$router.replace("/login");
          return;
        }
        this.ravenAppId = Parse.User.current().get('CompanyId').id;
        this.userEmail = Parse.User.current().get('email');
        FullStory.identify(Parse.User.current().id, {
        email: this.userEmail
        });

        this.$emit('validated-user', this.ravenAppId);
      });
    } else {
      console.log('local storage parseuser was null');
      this.$router.replace("/login");
    }
  },
  data: function () {
    return {
      ravenAppId : {},
      userEmail : ''
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('parseuser');
      Parse.User.logOut()
      .catch(function(e) {console.log(e)})
      .then(() => {
        
        this.$router.replace("/login");
      })
    }
  }
}
</script>

<style >
.app-id-display {
  color: white !important;
  padding-right: 20px;
  font-weight: bold;
}
.nav-item-text {
  color: white !important;
}
.navbar-brand {
  font-weight: bold;
}
.nav-item-text a {
  color:#efebf1 !important;
  font-weight: bold;
}
</style>
